import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import FooterContext from "../../../context/FooterContext/FooterContext";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import Dividers from "../../../common/divider";
import { SocialTypes } from "../../../../constant";
import { options } from "../../../constant";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import { Trash2, UploadCloud } from "react-feather";
import { IconButton } from "@mui/material";
import { delete_Multi_Image_Permanent } from "../apis/SliderApi/SliderApi";
import { randomStr } from "../../../../utils/helper";
import { getSocialMediaMaster } from "../apis/SocialMediaApi/SocialMediaApi";
import { Close } from "@material-ui/icons";
import Select from "react-select";

const FooterThree = (props) => {
  const { imageUpload } = props;
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const {
    isEdit,
    footerThreeForm,
    setIsSectionImage,
    setCustomeIndex,
    setFooterThreeForm,
  } = useContext(FooterContext);
  const [socialMediaMaster, setSocialMediaMaster] = useState([]);

  /**
   * get social media master list
   */
  const getSocialMediaMasterApi = async () => {
    try {
      let paramObj = {
        showAll: true,
      };
      const { data } = await getSocialMediaMaster(paramObj);
      if (data.status === 200) {
        setSocialMediaMaster(data.payload.data);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  useEffect(() => {
    getSocialMediaMasterApi();
  }, []);

  /**
   * input value change
   * @param {event} e
   */
  const changeFormValue = (e) => {
    const { value, name } = e.target;
    setFooterThreeForm((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
      };
      return updatedData;
    });
  };
  const changeFormValueAddress1 = (e) => {
    const { value, name } = e.target;
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        address1: {
          ...prev.address1,
          [name]: value,
        },
      };
    });
  };
  const changeFormValueAddress2 = (e) => {
    const { value, name } = e.target;
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        address2: {
          ...prev.address2,
          [name]: value,
        },
      };
    });
  };

  const handleSocialMediaChange = (e, i) => {
    const { name, value, options, selectedIndex } = e.target;
    let old = [...footerThreeForm.socialMedia];
    old[i][name] = value;
    if (name === "type") {
      old[i]["name"] = options[selectedIndex].text;
    }
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        socialMedia: old,
      };
    });
  };
  const handleSocialMediaChangeDialCode = (e, i) => {
    let old = [...footerThreeForm.socialMedia];
    old[i]["dialCode"] = e;
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        socialMedia: old,
      };
    });
  };

  const deleteImagePermanent = async (imgType, index) => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData;
        let social = [...footerThreeForm.socialMedia];
        if (imgType === "FooterLogo") {
          formData = {
            fileName: footerThreeForm?.footerLogo
              .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
              .pop(),
          };
        } else if (imgType === "socialImage") {
          let imageName = social[index];
          formData = {
            fileName: imageName.image
              .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
              .pop(),
          };
        }
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          TostMessage({ message: data, type: "success", position: "center" });
          setFooterThreeForm((prev) => {
            if (imgType === "FooterLogo") {
              return {
                ...prev,
                footerLogo: "",
                image: "",
              };
            } else if (imgType === "socialImage") {
              social[index]["image"] = "";
              return {
                ...prev,
                image: "",
                socialMedia: social,
              };
            }
          });

          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };
  const addMoreInput = () => {
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        socialMedia: [
          ...prev.socialMedia,
          { name: "", value: "", id: randomStr(2) },
        ],
      };
    });
  };
  const deleteMoreInput = (id) => {
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        socialMedia: prev.socialMedia.filter((item) => item.id !== id),
      };
    });
  };
  /**
   * reupload image
   */
  const reupload = () => {
    setFooterThreeForm((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center ">
              <h6>{isEdit ? "Edit" : "Add New"}</h6>
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Address Title 1</Label>
                  <Input
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title"
                    value={footerThreeForm?.address1?.title}
                    onChange={(e) => changeFormValueAddress1(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Address 1</Label>
                  <Input
                    className="form-control"
                    name="address"
                    type="text"
                    placeholder="Address"
                    value={footerThreeForm?.address1?.address}
                    onChange={(e) => changeFormValueAddress1(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">
                    Enter Google Map Link
                  </Label>
                  <Input
                    className="form-control"
                    name="locationLink"
                    type="text"
                    placeholder="Google Map Link Link"
                    value={footerThreeForm?.address1?.locationLink}
                    onChange={(e) => changeFormValueAddress1(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Row>
                  <Col md="3 mb-3">
                    <Label htmlFor="validationCustom03">DialCode</Label>
                    <Select
                      style={{ width: "125px" }}
                      options={options}
                      name="dialCode"
                      isSearchable={true}
                      value={footerThreeForm?.address1?.dialCode}
                      onChange={(prev) => {
                        setFooterThreeForm((prevValue) => {
                          return {
                            ...prevValue,
                            address1: {
                              ...prevValue.address1,
                              dialCode: prev,
                            },
                          };
                        });
                      }}
                    />
                  </Col>
                  <Col md="9 mb-3">
                    <Label htmlFor="validationCustom03">Phone</Label>
                    <Input
                      className="form-control"
                      name="phone"
                      type="number"
                      placeholder="Phone"
                      value={footerThreeForm?.address1?.phone}
                      onChange={(e) => changeFormValueAddress1(e)}
                      style={{ borderRadius: "0", color: "black" }}
                      required
                    />
                  </Col>
                </Row>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Email</Label>
                  <Input
                    className="form-control"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={footerThreeForm?.address1?.email}
                    onChange={(e) => changeFormValueAddress1(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <hr />
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Address Title 2</Label>
                  <Input
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title"
                    value={footerThreeForm?.address2?.title}
                    onChange={(e) => changeFormValueAddress2(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Address 2</Label>
                  <Input
                    className="form-control"
                    name="address"
                    type="text"
                    placeholder="Address"
                    value={footerThreeForm?.address2?.address}
                    onChange={(e) => changeFormValueAddress2(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">
                    Enter Google Map Link
                  </Label>
                  <Input
                    className="form-control"
                    name="locationLink"
                    type="text"
                    placeholder="Google Map Link Link"
                    value={footerThreeForm?.address2?.locationLink}
                    onChange={(e) => changeFormValueAddress2(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Row>
                  <Col md="3 mb-3">
                    <Label htmlFor="validationCustom03">DialCode</Label>
                    <Select
                      style={{ width: "125px" }}
                      options={options}
                      name="dialCode"
                      isSearchable={true}
                      value={footerThreeForm.address2?.dialCode}
                      onChange={(prev) =>
                        setFooterThreeForm((prevValue) => {
                          return {
                            ...prevValue,
                            address2: {
                              ...prevValue.address2,
                              dialCode: prev,
                            },
                          };
                        })
                      }
                    />
                  </Col>
                  <Col md="9 mb-3">
                    <Label htmlFor="validationCustom03">Phone</Label>
                    <Input
                      className="form-control"
                      name="phone"
                      type="number"
                      placeholder="Phone"
                      value={footerThreeForm?.address2?.phone}
                      onChange={(e) => changeFormValueAddress2(e)}
                      style={{ borderRadius: "0", color: "black" }}
                      required
                    />
                  </Col>
                </Row>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Email</Label>
                  <Input
                    className="form-control"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={footerThreeForm?.address2?.email}
                    onChange={(e) => changeFormValueAddress2(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <hr />
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Content</Label>
                  <textarea
                    className="form-control"
                    name="content"
                    type="text"
                    placeholder="Content"
                    cols={5}
                    value={footerThreeForm?.content}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="6 mb-3">
                  <Label htmlFor="validationCustom03">Footer Logo</Label>
                  <div
                    className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    {!footerThreeForm.footerLogo && (
                      <span
                        onClick={() => {
                          OpenModalCommonFunc(
                            Cases.PRODUCT_UPLOAD,
                            setAllPopupState
                          );
                          setIsSectionImage("footer3Logo");
                        }}
                      >
                        <UploadCloud />
                      </span>
                    )}

                    {footerThreeForm.footerLogo && (
                      <img
                        src={footerThreeForm.footerLogo}
                        alt=""
                        style={{
                          width: "85%",
                          height: "90px",
                          objectFit: "contain",
                          position: "absolute",
                        }}
                        onClick={() => {
                          deleteImagePermanent("FooterLogo");
                        }}
                      />
                    )}
                    {footerThreeForm.footerLogo && (
                      <>
                        {" "}
                        <IconButton
                          edge="start"
                          color="inherit"
                          aria-label="close"
                          style={{
                            color: "red",
                            position: "absolute",
                            top: "-22px",
                            left: "1px",
                          }}
                          onClick={() => deleteImagePermanent("FooterLogo")}
                        >
                          <Close
                            style={{ fontSize: "25px", fontWeight: "bold" }}
                          />
                        </IconButton>
                      </>
                    )}
                  </div>
                </Col>
                <Dividers divide={"Social Media"} />
                {footerThreeForm?.socialMedia?.map((elem, i) => {
                  return (
                    <Row key={elem.id}>
                      {elem.type === SocialTypes.custom && (
                        <Col md="3 mb-3">
                          <div
                            className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            <span
                              onClick={() => {
                                OpenModalCommonFunc(
                                  Cases.PRODUCT_UPLOAD,
                                  setAllPopupState
                                );
                                setIsSectionImage(false);
                                setCustomeIndex(i);
                              }}
                            >
                              <UploadCloud />
                            </span>
                            {elem?.image && (
                              <img
                                src={
                                  `${process.env.REACT_APP_BUCKET_URL}/${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/${elem?.image}` ||
                                  ""
                                }
                                alt=""
                                style={{
                                  width: "80%",
                                  height: "60%",
                                  objectFit: "contain",
                                  position: "absolute",
                                }}
                                onClick={() => {
                                  deleteImagePermanent("socialImage", i);
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      )}

                      <Col md="3 mb-3">
                        <Label htmlFor="type">{"Type *"}</Label>
                        <select
                          className="form-control"
                          style={{ borderRadius: "0", color: "black" }}
                          value={elem.type}
                          onChange={(e) => handleSocialMediaChange(e, i)}
                          name="type"
                        >
                          <option value="">--select--</option>
                          {socialMediaMaster.map((social) => {
                            return (
                              <option
                                value={social.type}
                                disabled={footerThreeForm?.socialMedia.some(
                                  (elem) => elem.type === social.type
                                )}
                              >
                                {social.label}
                              </option>
                            );
                          })}
                        </select>
                      </Col>
                      <Col md="3 mb-3">
                        <Label htmlFor="validationCustom03">{"Name"}</Label>
                        <Input
                          className="form-control"
                          name="name"
                          type="text"
                          placeholder="Name"
                          value={elem.name}
                          onChange={(e) => handleSocialMediaChange(e, i)}
                          style={{ borderRadius: "0", color: "black" }}
                        />
                      </Col>
                      {elem.type === SocialTypes.whatsapp && (
                        <Col md="3 mb-3">
                          <Label htmlFor="validationCustom03">
                            {"Dial Code*"}
                          </Label>
                          <Select
                            style={{ width: "125px" }}
                            options={options}
                            name="dialCode"
                            value={elem.dialCode}
                            onChange={(e) =>
                              handleSocialMediaChangeDialCode(e, i)
                            }
                          />
                        </Col>
                      )}
                      <Col md="3 mb-3">
                        <Label htmlFor="validationCustom03">{"Value"}</Label>
                        <div className="d-flex ">
                          <Input
                            className="form-control"
                            name="value"
                            type="text"
                            placeholder="Value"
                            value={elem.value}
                            onChange={(e) => handleSocialMediaChange(e, i)}
                            style={{ borderRadius: "0", color: "black" }}
                          />
                          {footerThreeForm.socialMedia.length >= 2 && (
                            <IconButton
                              edge="start"
                              color="inherit"
                              style={{ marginLeft: "5px", color: "red" }}
                              onClick={() => deleteMoreInput(elem.id)}
                            >
                              <Trash2 />
                            </IconButton>
                          )}
                        </div>
                      </Col>
                    </Row>
                  );
                })}
                <div className="d-flex justify-content-center ">
                  <Button onClick={() => addMoreInput()} color="primary">
                    + Add More
                  </Button>
                </div>
              </Row>
            </div>
          </Col>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={footerThreeForm.image}
          setImage={setFooterThreeForm}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          // aspect={1 / 1}
        />
      </Container>
    </>
  );
};

export default FooterThree;
